import React, { useEffect, useState } from "react";
import Loader from "../../Shared/Loader";

// import { useMsal } from "@azure/msal-react";
// import { apiScopes } from "../../config/msalConfig";
import "../../../css/ViewRoleModal.css";
import ConfirmationModal from "./ConfirmationModal";
import axios from "axios";
import api from '../../../api/axiosConfig';
import { showToast } from '../../Shared/Toaster';


interface Form {
  _id: string;
  name: string;
  category?: string;
}

interface Role {
  _id: string;
  name: string;
  type: string;
  details?: string;
  isActive: boolean;
  createdAt: string;
  disabledOn?: string | null;
  parent: string | null;
  formIds: Form[];
  updatedAt: string;
}

interface ViewSubRoleModalProps {
  subRoleId: string;
  onClose: () => void;
  onUpdate: (updatedRole: Role) => void;
}

const ViewSubRoleModal: React.FC<ViewSubRoleModalProps> = ({
  subRoleId,
  onClose,
  onUpdate,
}) => {
  // const { instance, accounts } = useMsal();
  const [subRole, setSubRole] = useState<Role | null>(null);
  const [formState, setFormState] = useState<Role | null>(null);
  const [forms, setForms] = useState<Form[]>([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // 🔹 Fetch sub-role + forms
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await instance.acquireTokenSilent({
        //   ...apiScopes,
        //   account: accounts[0],
        // });
        // const token = response.accessToken;

        const token = sessionStorage.getItem("accessToken");

        // Sub-Role
        const resSubRole = await api.auth_api.get<Role>(`/roles/${subRoleId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSubRole(resSubRole.data);
        setFormState(resSubRole.data);

        // Forms
        const resForms = await api.auth_api.get<Form[]>("/forms", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForms(resForms.data);
      } catch (err) {
        console.error("❌ Error fetching sub-role/forms:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [subRoleId]);

  // 🔹 Handle input change
  const handleChange = (field: keyof Role, value: any) => {
    if (!formState) return;
    setFormState({ ...formState, [field]: value });
  };

  // 🔹 Checkbox handler
  const handleCheckboxChange = (form: Form) => {
    if (!formState) return;
    const alreadySelected = formState.formIds.some((f) => f._id === form._id);

    const updatedForms = alreadySelected
      ? formState.formIds.filter((f) => f._id !== form._id)
      : [...formState.formIds, form];

    setFormState({ ...formState, formIds: updatedForms });
  };

  // 🔹 Save (PATCH)
  const handleSave = async () => {
    if (!formState) return;
    try {
      // const response = await instance.acquireTokenSilent({
      //   ...apiScopes,
      //   account: accounts[0],
      // });
      // const token = response.accessToken;

      const token = sessionStorage.getItem("accessToken");

      const res = await api.auth_api.patch<Role>(`/roles/subroles/${subRoleId}`,
        {
          name: formState.name,
          key: formState.name,
          type: formState.type,
          details: formState.details,
          isActive: formState.isActive,
          formIds: formState.formIds.map((f) => f._id),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSubRole(res.data);
      setFormState(res.data);
      setIsEditing(false);

      showToast("✅ Sub-role updated successfully!", 'success');
      onUpdate(res.data);
      onClose();
    } catch (err) {
      console.error("❌ Error updating sub-role:", err);
      showToast("Failed to update sub-role.", 'error');
    }
  };

  // 🔹 Disable (PATCH toggle)
  const handleDisable = async () => {
    if (!subRole) return;
    try {
      // const response = await instance.acquireTokenSilent({
      //   ...apiScopes,
      //   account: accounts[0],
      // });
      // const token = response.accessToken;

      const token = sessionStorage.getItem("accessToken");

      const res = await api.auth_api.patch<Role>(`/roles/subroles/${subRoleId}/toggle`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSubRole(res.data);
      setFormState(res.data);

      showToast(
        `✅ Sub-role ${res.data.isActive ? "enabled" : "disabled"} successfully!`
      , 'success');
      onUpdate(res.data);
      onClose();
    } catch (err) {
      console.error("❌ Error toggling sub-role:", err);
      showToast("Failed to toggle sub-role.", 'error');
    } finally {
      setShowConfirm(false);
    }
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal">
          <Loader text="Loading Sub-Role Details..." />
        </div>
      </div>
    );
  }

  if (!subRole || !formState) return null;

  // 🔹 Group forms
  // const groupedForms: Record<string, Form[]> = {
  //   ADMIN: forms.filter((f) => f.category?.toUpperCase() === "ADMIN"),
  //   STAFF: forms.filter((f) => f.category?.toUpperCase() === "STAFF"),
  //   TELE: forms.filter((f) => f.category?.toUpperCase() === "TELE"),
  // };


  const groupedForms: Record<string, Form[]> = {
  "QAVACH STAFF": forms.filter(
    (f) => f.category?.toUpperCase() === "QAVACH STAFF"
  ),
  "TELE SPECIALIST": forms.filter(
    (f) => f.category?.toUpperCase() === "TELE SPECIALIST"
  ),
};

  return (
    <div className="view-role-modal-overlay" onClick={onClose}>
      <div className="view-role-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="view-role-modal-header">
          <h3>View Sub-Role</h3>
          <button className="view-role-close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Sub-Role Name */}
        <div className="form-group">
          <label>Sub-Role Name:</label>
          {isEditing ? (
            <input
              type="text"
              className="form-input"
              value={formState.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          ) : (
            <p className="field-value">{subRole.name}</p>
          )}
        </div>

        {/* Role Type */}
        <div className="form-group">
          <label>Role Type:</label>
          {isEditing ? (
            <input
              type="text"
              className="form-input"
              value={formState.type}
              onChange={(e) => handleChange("type", e.target.value)}
            />
          ) : (
            <p className="field-value">{subRole.type}</p>
          )}
        </div>

        {/* Status */}
        <div className="form-group">
          <label>Status:</label>
          {isEditing ? (
            <select
              className="form-input"
              value={formState.isActive ? "Active" : "Inactive"}
              onChange={(e) =>
                handleChange("isActive", e.target.value === "Active")
              }
            >
              <option>Active</option>
              <option>Inactive</option>
            </select>
          ) : (
            <p className="field-value">
              {subRole.isActive ? "Active" : "Inactive"}
            </p>
          )}
        </div>

        {/* Details */}
        <div className="form-group">
          <label>Details:</label>
          {isEditing ? (
            <textarea
              className="form-input"
              value={formState.details || ""}
              onChange={(e) => handleChange("details", e.target.value)}
            />
          ) : (
            <p className="field-value">{subRole.details || "-"}</p>
          )}
        </div>

        {/* Created On */}
        <div className="form-group">
          <label>Created On:</label>
          <p className="field-value">
            {new Date(subRole.createdAt).toLocaleDateString()}
          </p>
        </div>

        {/* Disabled On */}
        <div className="form-group">
          <label>Disabled On:</label>
          <p className="field-value">
            {subRole.disabledOn
              ? new Date(subRole.disabledOn).toLocaleDateString()
              : "-"}
          </p>
        </div>

        {/* Assigned Forms */}
        <div className="view-role-form-group">
          <label>Assigned Forms:</label>
          {isEditing ? (
            <div className="view-role-form-groups">
              {Object.entries(groupedForms).map(([category, categoryForms]) => (
                <div key={category}>
                  <h4>{category}</h4>
                  {categoryForms.length > 0 ? (
                    categoryForms.map((form) => (
                      <label key={form._id}>
                        <input
                          type="checkbox"
                          checked={formState.formIds.some(
                            (f) => f._id === form._id
                          )}
                          onChange={() => handleCheckboxChange(form)}
                        />
                        {form.name}
                      </label>
                    ))
                  ) : (
                    <p className="empty-text">No forms available</p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <ul className="form-list">
              {subRole.formIds.map((form) => (
                <li key={form._id}>{form.name}</li>
              ))}
            </ul>
          )}
        </div>

        {/* Buttons */}
        <div className="modal-actions">
          {isEditing ? (
            <button className="btn btn-save" onClick={handleSave}>
              Save Changes
            </button>
          ) : (
            <button className="btn btn-edit" onClick={() => setIsEditing(true)}>
              Edit
            </button>
          )}
          <button
            className="btn btn-disable"
            onClick={() => setShowConfirm(true)}
          >
            {subRole.isActive ? "Disable" : "Enable"}
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirm && (
        <ConfirmationModal
          message={`Are you sure you want to ${
            subRole.isActive ? "disable" : "enable"
          } this sub-role?`}
          onConfirm={handleDisable}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default ViewSubRoleModal;
